<template>
    <div class="text-center" v-if="loader == true">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
        <div>
            <v-layout column>
                <v-flex xs6 offset-xs6>
                    <v-layout align-center justify-end fill-height>
                        <v-btn rounded color="primary" class="text-capitalize mr-2" to="/events/new"
                            v-if="$can('create events')">
                            Créer
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                        <div v-if="current_event">
                            <v-btn rounded color="light-blue" class="text-capitalize"
                                @click="editEvent(current_event.id)" v-if="$can('edit events') &&
                                    current_event.is_past == false
                                ">
                                <span text-color="white">Editer</span>
                                <v-icon right color="white">mdi-pencil-outline</v-icon>
                            </v-btn>
                        </div>

                        <div v-if="current_event">
                            <v-btn rounded color="warning" class="text-capitalize" @click="isClosingEvent()" v-if="$can('create events') &&
                                current_event.is_past == false
                            ">
                                Clôturer
                                <v-icon right>mdi-alarm-note-off</v-icon>
                            </v-btn>
                        </div>

                        <v-btn rounded color="error" class="text-capitalize" @click="isDeletingEvent()"
                            v-if="$can('delete events')">
                            Supprimer
                            <v-icon right>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>



        <v-card class="mt-3 mb-3">
            <v-card-text v-if="current_event">
                <v-container fluid grid-list-md>
                    <v-layout row wrap align-center>
                        <v-flex xs5 v-if="current_event">
                            <span class="name-size">{{
                                current_event.name
                            }}</span>
                            <br />
                            <span class="couleur-orange" v-if="current_event.domain">{{ current_event.domain.name
                                }}</span>
                        </v-flex>

                        <v-flex xs4>
                            <span class="name-size">Coordonnée par :</span>
                            <ul v-for="responsable in current_event.users" :key="responsable.id"
                                class="primary--text newTaille">
                                <li v-if="responsable.profile">
                                    {{ responsable.profile.first_name }}
                                    {{ responsable.profile.last_name }}
                                </li>
                            </ul>
                            <br />
                        </v-flex>

                        <v-flex xs3 class>
                            <span class="newTaille">
                                <v-icon left>mdi-calendar</v-icon>
                                {{
                                    current_event.event_date
                                    | moment("D MMMM YYYY")
                                }}
                                {{
                                    current_event.event_time
                                    | moment("HH:mm:ss")
                                }}
                            </span>

                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>

        <v-layout grid-list-sm v-if="current_event">
            <v-flex xs7 class="mr-3">
                <v-card>
                    <v-card-text class="newTaille">
                        <h4>Objective</h4>
                        {{ current_event.objective }}
                        <br />
                        <br />
                        <h4>Type</h4>
                        <i v-if="current_event.event_type">
                            {{
                                current_event.event_type.name.length < 80 ? current_event.event_type.name :
                                    current_event.event_type.name.substring(0, 80) + " ..." }} </i>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs5>
                <v-card>
                    <v-card-text class="newTaille">
                        <h4>Chaine de valeur</h4>
                        <span v-for="laChaine in current_event.chains" :key="laChaine.id">- {{ laChaine.name }}</span>
                    </v-card-text>
                </v-card>

                <v-card class="mt-2">
                    <v-card-text class="newTaille">
                        <v-icon>mdi-map-marker</v-icon>
                        {{
                            current_event != null &&
                                current_event.country != null
                                ? current_event.country.name
                                : ""
                        }},
                        {{
                            current_event != null &&
                                current_event.department != null
                                ? current_event.department.name
                                : ""
                        }},
                        {{
                            current_event != null &&
                                current_event.municipality != null
                                ? current_event.municipality.name
                                : ""
                        }},
                        {{
                            current_event != null &&
                                current_event.district != null
                                ? current_event.district.name
                                : ""
                        }},
                        {{
                            current_event != null && current_event.town != null
                                ? current_event.town.name
                                : ""
                        }},
                        {{
                            current_event != null && current_event.place != null
                                ? current_event.place
                                : ""
                        }}
                        <br />
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-layout grid-list-sm v-if="current_event">
            <v-flex xs7 class="mr-3">
                <v-card>
                    <v-card-text class="newTaille">
                        <h4>Organisateur de l'évènement</h4>
                        {{ current_event.event_organiser }}
                        <br />
                        <br />
                        <h4>SAE</h4>
                        <span v-if="current_event.sae_type">{{
                            current_event.sae_type.name
                        }}</span>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs5>
                <v-card>
                    <v-card-text class="newTaille">
                        <h4>Nom du staff ACMA3 impliqué</h4>
                        {{ current_event.staff_name }}
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>



        <v-card flat class="mt-5">
            <v-card-title>
                <h5 class="primary--text">Liste des participants</h5>
                <v-spacer></v-spacer>

                <div v-if="current_event">
                    <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                        @click="deleting(selected)" v-if="$can('delete any actor')">
                        Supprimer
                        <v-icon right>mdi-trash-can-outline</v-icon>
                    </v-btn>
                    <v-btn rounded color="primary" class="text-capitalize" @click="dialog_add = true">
                        Ajouter participants
                        <v-icon right>mdi-plus</v-icon>
                    </v-btn>


                    <v-btn rounded color="primary" class="text-capitalize mr-2" @click="listCards()"
                        v-if="$can('view cards')">
                        Voir cartes
                        <v-icon right>mdi-eye-outline</v-icon>
                    </v-btn>
                    <v-btn rounded color="primary" class="text-capitalize mr-2" @click="dowloadCards()"
                        v-if="$can('view cards')">
                        Télécharger les cartes
                        <v-icon right>mdi-eye-outline</v-icon>
                    </v-btn>
                    <v-btn rounded color="primary" class="text-capitalize" @click="importActor()">
                        Importer des participant
                        <v-icon right>mdi-database-import</v-icon>

                    </v-btn>
                    <v-btn rounded color="primary" class="text-capitalize" @click="dialog_import_excel = true">
                        Importer un fichier Excel
                        <v-icon right>mdi-file-excel</v-icon>
                    </v-btn>

                    <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                        @click="generateCards(selected)" v-if="$can('generate cards')">
                        Générer cartes
                        <v-icon right>mdi-account-card-details-outline</v-icon>
                    </v-btn>
                </div>
                <br>
                <br>
                <v-spacer></v-spacer>
                <v-text-field v-model="search_name" label="Filtrer par nom" solo @keyup="searchWithDelay()"
                    class="mr-2">
                </v-text-field>
            </v-card-title>
        </v-card>

        <v-flex xs12>
            <div v-if="selected" class="mr-2">
                {{ selected.length }} / {{ current_event.actors.length }} sélectionnés
            </div>
        </v-flex>
        <v-data-table v-if="current_event" v-model="selected" :headers="role == 'super administrator' || role == 'administrateur'
            ? adminHeaders
            : headers
            " :items="current_event.actors" item-key="id" class="elevation-1 newTaille" :page.sync="pagination.current"
            show-select :items-per-page="10" @page-count="pagination.last_page = $event">
            <template v-slot:item.pivot.present="{ item }">
                <span v-if="item.pivot.present == 1">Oui</span>
                <span v-else-if="item.pivot.present == 0">Non</span>
            </template>
            <template v-slot:item.have_card="{ item }">
                <td v-if="item.card">
                    Oui
                </td>
                <td v-else>
                    Non
                </td>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small @click="deleting(item)" v-if="$can('delete own actors') || $can('delete any actor')">
                    mdi-trash-can-outline
                </v-icon>
            </template>

        </v-data-table>

        <div class="text-xs-center mt-2">
            <v-pagination v-model="pagination.current" :length="pagination.last_page"
                @input="reloadEventActors"></v-pagination>
        </div>

        <v-snackbar v-model="snackbar" :timeout="timeout" color="primary" :top="true" :right="true">
            {{ snackbar_message }}
        </v-snackbar>

        <v-snackbar v-model="snackbar_error" :timeout="timeout" color="primary" :top="true" :right="true">
            {{ snackbar_message }}
        </v-snackbar>

        <!--       <v-card class="mx-auto pt-2" outlined v-if="current_event &&
        current_event.latitude &&
        current_event.longitude
        ">
            <v-card-title>Localisation de l'évènement</v-card-title>
            <v-card-text class="text--primary">
                <v-container class="pt-2" fluid fill-height>
                    <v-layout>
                        <v-flex x12>
                            <l-map style="height: 600px; width: 100%" :zoom="zoom" :center="center">
                                <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                <l-marker :lat-lng="markerLatLng"></l-marker>
                            </l-map>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card> -->
        <!--         <div v-if="current_event">
            <v-card class="mt-3" v-if="current_event.is_past == true">
                <v-card-title>
                    <h5 class="primary--text">
                        Statistiques sur les participants
                    </h5>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs9 class="newTaille">
                                <strong>Taux de participation de
                                    {{ (nb_present / nb_invite) * 100 }}
                                    %</strong>
                                soit {{ nb_absent }} absents sur
                                {{ nb_invite }} invités
                            </v-flex>
                            <v-flex xs3>
                                <v-btn color="primary" outlined small @click="export2image()">
                                    <v-icon class="mr-3">mdi-image-move</v-icon>Télécharger les graphes
                                </v-btn>
                            </v-flex>

                            <v-flex xs12>
                                <v-divider></v-divider>
                            </v-flex>

                            <v-flex xs6>
                                <stats-bar-chart ref="mychartbar" :data="age_chart_data"
                                    :options="bar_chart_options"></stats-bar-chart>
                            </v-flex>

                            <v-flex xs5 offset-xs1>
                                <stats-donut-chart ref="mychartdonut" :data="sexe_chart_data"
                                    :options="donut_chart_options"></stats-donut-chart>
                                <div class="text-center">
                                    <strong>Homme :</strong>
                                    {{ nb_homme }} |
                                    <strong>Femme :</strong>
                                    {{ nb_femme }}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </div> -->

        <v-layout row justify-center>
            <v-dialog v-model="dialog_closing" max-width="290">
                <v-card>
                    <v-card-title class="headline">Clôture</v-card-title>
                    <v-card-text class="text-center">Etes-vous sûr de vouloir clôturer cet évènement avant
                        sa date d'échéance?</v-card-text>
                    <v-card-actions>
                        <v-btn color="orange" rounded @click="dialog_closing = false">
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" rounded @click="cloturerEvent()">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text class="text-center">Etes-vous sûr de vouloir supprimer cet évènement
                        ?</v-card-text>
                    <v-card-actions>
                        <v-btn color="orange" rounded @click="dialog_deletion = false">
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" rounded @click="delEvent()">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_export" max-width="290">
                <v-card>
                    <v-card-title class="headline">Exportation</v-card-title>
                    <v-card-text class="text-center">Voulez-vous exporter avec entête de page ?</v-card-text>
                    <v-card-actions>
                        <v-btn color="orange" rounded @click="printTable(false)">
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" rounded @click="printTable(true)">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_import_excel" max-width="550">
                <v-card>
                    <v-card-title class="headline">Importer des participants (Excel)</v-card-title>
                    <v-card-text>
                        <p>
                            Le fichier doit avoir le même en-tête que initia_actor.xlsx :
                            <b>Mobile No., Name, Village, District/LGA, Region/State, Département, Gender, Crops Grown</b>.
                        </p>
                        <v-btn text small color="primary" class="text-none px-0 mb-3"
                            href="/templates/modele_import_participants.xlsx" download>
                            <v-icon left>mdi-download</v-icon>
                            Télécharger le modèle de fichier
                        </v-btn>
                        <p>
                            Les acteurs déjà enregistrés dans la même commune (même téléphone ou même nom) sont
                            rattachés à l'évènement sans être recréés. Le compte rendu et la liste des doublons
                            vous sont envoyés par e-mail à la fin de l'import.
                        </p>
                        <v-file-input v-model="import_excel_file" accept=".xlsx,.xls" label="Fichier Excel"
                            prepend-icon="mdi-file-excel" solo></v-file-input>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="orange" rounded @click="dialog_import_excel = false">
                            <span class="white-couleur">Annuler</span>
                        </v-btn>
                        <v-btn color="success" rounded :disabled="!import_excel_file"
                            @click="importExcel()">Importer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_add" max-width="390">
                <v-card>
                    <v-container grid-list-md>
                        <v-card-title class="headline">Ajout de participant</v-card-title>
                        <v-card-text class="text-center" v-if="!is_search">Quel type d'acteur voulez-vous ajouter
                            ?</v-card-text>
                        <v-card-text v-if="is_search" class="text-center">Entrer le numéro, nom, prénom ou code unique
                            de
                            l'acteur</v-card-text>
                        <v-flex xs12 v-if="is_search">
                            <v-text-field v-model="number" label="Numéro*" placeholder="Ex : 90909090" required solo>
                            </v-text-field>
                        </v-flex>
                        <div v-if="participants && !loading && is_search">

                            <v-layout column class="m-8">
                                <v-flex xs12>
                                    <v-layout align-center justify-end fill-height>
                                        <v-btn rounded color="primary" class="text-capitalize my-2"
                                            :disabled="selected.length < 1 || loading" @click="validating()"
                                            :loading="loading">
                                            Ajouter
                                            <v-icon right>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-flex xs12>
                                <div v-if="selected" class="mr-2">
                                    {{ selected.length }} / {{ current_event.actors.length }} sélectionnés
                                </div>
                            </v-flex>
                            <v-data-table v-model="selected"
                                :headers="role == 'super administrator' || role == 'administrateur' ? adminHeaders : headers"
                                :items="participants" item-key="id" class="elevation-1" show-select
                                :hide-default-footer="true">
                            </v-data-table>
                        </div>

                        <v-card-actions v-if="is_search">
                            <v-spacer></v-spacer>
                            <v-btn color="orange" rounded @click="is_search = false">
                                <span class="white-couleur">Retour</span>
                            </v-btn>
                            <v-btn color="success" :loading="loading" :disabled="loading" rounded
                                @click="fetchParticipants()">Rechercher</v-btn>
                        </v-card-actions>
                        <v-card-actions v-if="!is_search">
                            <v-spacer></v-spacer>
                            <v-btn color="success" rounded @click="redirect()">
                                <span class="white-couleur">Nouvel acteur</span>
                            </v-btn>
                            <v-btn color="orange" rounded @click="is_search = true">Ancien acteur</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-layout justify-center>
                <v-dialog v-model="dialog_generate" persistent hide-overlay max-width="290">
                    <v-card>
                        <v-card-title class="headline">{{
                            dialog_title
                        }}</v-card-title>
                        <v-card-text>{{ delete_message }}</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn rounded color="orange" @click="cancel()">Non</v-btn>
                            <v-btn :loading="loading" :disabled="loading" rounded color="primary"
                                @click="choosen()">Oui</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialog" persistent hide-overlay max-width="550">
                    <delete-with-password v-if="item" @cancel="cancel" @deleteItem="choosen" :item="item"
                        :message="delete_message" :title="dialog_title"></delete-with-password>
                </v-dialog>
            </v-layout>
        </v-layout>

        <div class="text-center">
            <v-dialog v-model="dialog_dowload" :scrim="false" persistent hide-overlay max-width="290">
                <v-card>
                    <v-card-title class="m-4">
                        Téléchargement en cours...
                        <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import BarChart from "../../components/BarChart";
import Doughnut from "../../components/DoughnutChart";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Permissions from "~/mixins/Permissions";
import DeleteWithPassword from "~/components/DeleteWithPassword";

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
    name: "event-show",
    mixins: [Permissions],
    components: {
        "stats-bar-chart": BarChart,
        "stats-donut-chart": Doughnut,
        ChartDataLabels,
        LMap,
        LTileLayer,
        LMarker,
        DeleteWithPassword
    },

    data: () => ({
        event_id: null,
        selected: [],
        timeout: 5000,
        snackbar: false,
        snackbar_error: false,
        snackbar_message: false,
        snackbar_message: '',

        headers: [
            {
                text: "code Unique",
                align: "center",
                value: "unique_code"
            },
            { text: "Type", value: "type", align: "center" },
            { text: "Langue", value: "language", align: "center" },
            { text: "Présence", value: "pivot.present", align: "center" },
            // { text: "Notification", value: "pivot.notified", align: "center" },
            { text: "Adresse", value: "address", align: "center" },
            { text: 'Dispose de carte', value: 'have_card', align: "center" },

        ],
        adminHeaders: [
            {
                text: "Code Unique",
                align: "center",
                value: "unique_code"
            },
            {
                text: "Nom complet",
                align: "center",
                value: "full_name"
            },
            { text: "Type", value: "type", align: "center" },
            { text: "Langue", value: "language", align: "center" },
            { text: "Présence", value: "pivot.present", align: "center" },
            // { text: "Notification", value: "pivot.notified", align: "center" },
            { text: "Adresse", value: "address", align: "center" },
            { text: "Contact", value: "contact", align: "center" },
            { text: 'Dispose de carte', value: "have_card", align: "center" },

            { text: "Actions", value: "action", sortable: false }
        ],

        search: "",
        number: "",
        dialog: false,
        dialog_deletion: false,
        dialog_export: false,
        dialog_closing: false,
        dialog_add: false,
        dialog_import_excel: false,
        import_excel_file: null,
        is_search: false,
        numeros: [],
        totalItems: null,
        ids: [],
        actors_fields: {
            Nom: "first_name",
            Prenom: "last_name",
            Sexe: "gender",
            Age: "age",
            Type: "type",
            Contact: "contact",
            Adresse: "address",
            Langue: "language",
            "Niveau d'instruction": "instruction_level",
            Fonction: "fonction"
        },
        tranche_age: ["-18", "18-24", "25-34", "35-44", "45-54", "55+"],
        tranche_sexe: ["Homme", "Femme"],

        age_chart_data: {},
        sexe_chart_data: {},
        nb_homme: 0,
        nb_femme: 0,

        bar_chart_options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    anchor: "end",
                    align: "center",
                    formatter: Math.round,
                    font: {
                        weight: "bold",
                        size: 14
                    },
                    display: function (context) {
                        var index = context.dataIndex;
                        var value = context.dataset.data[index];
                        return value != 0;
                    }
                }
            }

        },

        donut_chart_options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    color: "#FFFFFF",
                    anchor: "center",
                    align: "center",
                    formatter: Math.round,
                    font: {
                        weight: "bold",
                        size: 16
                    },
                    display: function (context) {
                        var index = context.dataIndex;
                        var value = context.dataset.data[index];
                        return value != 0;
                    }
                }
            }
        },
        nb_absent: 0,
        nb_present: 0,
        nb_invite: 0,
        pagination: {
            current: 1,
            last_page: 0,
            total: 0
        },
        loadingSave: false,
        loading: false,
        searchTimer: null,
        search_name: "",
        loader: true,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 7,
        center: [9.239, 2.31],
        markerLatLng: [],
        role: "",
        dialog_dowload: false,
        participants: null,
        item: null,
        isSingleDelete: false,
        isBulkDelete: false,
        dialog_title: "",
        delete_message: "",
        dialog_generate: "",
        isValidate: false,
        isBulkGenerate: false,
    }),

    computed: {
        current_event() {
            let event = this.$store.getters.getCurrentEvent;
            if (event.latitude && event.longitude) {
                this.markerLatLng = [event.latitude, event.longitude];
            }
            return event;
        },
        authUser() {
            return this.$store.getters.authUser;
        }

    },
    created() {
        this.$checkPermission("view events");
        this.fetchUtils();
    },

    methods: {
        async generateCards(data) {
            if (Array.isArray(data) && data.length > 1) {
                this.ids = this.selected.map((data) => {
                    return data.id;
                });
                this.isBulkGenerate = true;
                this.dialog_title = "Génération de cartes";
                this.delete_message =
                    "Etes-vous sûr de vouloir générer des cartes pour ces acteurs ?";
                this.dialog_generate = true;
            } else {
                if (Array.isArray(data) && data.length === 1) {
                    this.actorId = data[0].id
                } else {
                    this.actorId = data.id
                }

                this.isSingleGenerate = true
                this.dialog_title = 'Génération de cartes'
                this.delete_message =
                    "Etes-vous sûr de vouloir générer une carte pour cet acteur ?";
                this.dialog_generate = true;
            }
        },
        async listCards() {
            this.$router.push({ name: 'events.participant.card', params: { Pid: this.$route.params.Pid } })
        },
        async importActor() {
            this.$router.push({ name: 'events.participant', params: { Pid: this.$route.params.Pid } })
        },
        importExcel() {
            const name = this.import_excel_file.name.toLowerCase()
            if (!name.endsWith('.xlsx') && !name.endsWith('.xls')) {
                this.snackbar_error = true
                this.snackbar_message = 'Le fichier doit être au format Excel (.xlsx ou .xls).'
                return
            }

            // Pas d'attente : le résultat de l'envoi s'affiche dans le message global
            this.$store.dispatch('importEventActors', {
                eventId: this.$route.params.Pid,
                file: this.import_excel_file
            })
            this.dialog_import_excel = false
            this.import_excel_file = null
        },
        async fetchUtils() {
            this.loader = true;
            if (
                this.authUser &&
                this.authUser.user &&
                this.authUser.user.roles[0]
            ) {
                this.role = this.authUser.user.roles[0].name;
            }
            this.event_id = this.$route.params.Pid;
            await this.$store
                .dispatch("loadCurrentEvent", this.event_id)
                .then(() => {
                    this.loader = false;
                });

            let objet = {};
            objet.event_id = this.event_id;
            objet.page = this.pagination ? this.pagination.current : 1;
            this.$store.dispatch("loadEventActors", objet);
        },

        reloadEventActors() {
            let objet = {};
            objet.event_id = this.event_id;
            objet.page = this.pagination.current;
            this.$store.dispatch("loadEventActors", objet);
        },
        redirect() {
            this.$router.push({
                name: "actors.new",
                params: { actorId: "new", eventId: this.event_id }
            });
        },

        set_chart_data() {
            let people = this.current_event ? this.current_event.actors : [];
            let age1 = 0;
            let age2 = 0;
            let age3 = 0;
            let age4 = 0;
            let age5 = 0;
            let age6 = 0;
            let sexeH = 0;
            let sexeF = 0;
            let homme = "Homme";
            let absent = 0;
            let present = 0;
            let invite = 0;

            people.forEach(function (item, index) {
                invite++;
                let is_presence = item.pivot.present;
                if (is_presence == 1) {
                    present++;
                    let age = item.age;
                    let sexe = item.gender;

                    if (age < 18) {
                        age1++;
                    } else if (age >= 18 && age <= 24) {
                        age2++;
                    } else if (age >= 25 && age <= 34) {
                        age3++;
                    } else if (age >= 35 && age <= 44) {
                        age4++;
                    } else if (age >= 45 && age <= 54) {
                        age5++;
                    } else {
                        age6++;
                    }

                    if (sexe.localeCompare(homme) == 0) {
                        sexeH = sexeH + 1;
                    } else {
                        sexeF = sexeF + 1;
                    }
                } else {
                    absent++;
                }
            });

            let tab_val = [];
            tab_val.push(age1, age2, age3, age4, age5, age6);

            let tab_val_sexe = [];
            tab_val_sexe.push(sexeH, sexeF);

            let valeurs = [
                {
                    label: "Tranche d'age des participants",
                    backgroundColor: [
                        "#e91e63",
                        "#9c27b0",
                        "#2196f3",
                        "#4caf50",
                        "#ff9800",
                        "#ffc107"
                    ],
                    data: tab_val
                }
            ];

            let valeurs_sexe = [
                {
                    backgroundColor: ["#4caf50", "#e91e63"],
                    data: tab_val_sexe
                }
            ];

            let age_data = {};
            age_data.labels = this.tranche_age;
            age_data.datasets = valeurs;

            let sexe_data = {};
            sexe_data.labels = this.tranche_sexe;
            sexe_data.datasets = valeurs_sexe;

            this.age_chart_data = age_data;
            this.sexe_chart_data = sexe_data;

            this.nb_homme = sexeH;
            this.nb_femme = sexeF;
            this.nb_absent = absent;
            this.nb_present = present;
            this.nb_invite = invite;
        },

        editEvent(id) {
            let payload = {};
            payload.event_id = id;
            payload.router = this.$router;

            this.$store.dispatch("loadEditableEvent", payload);
        },

        isDeletingEvent() {
            this.dialog_deletion = true;
        },

        deletingActor() {
            this.dialog_deletion = true;
        },

        delEvent() {
            let uri = "/api/events/" + this.event_id;
            let route_obj = this.$router;

            axios
                .delete(uri)
                .then(response => {
                    route_obj.push({
                        name: "events.coming",
                        params: { event_deleted: true }
                    });
                })
                .catch(err => {
                    console.log("Event deletion error ", err);
                });
        },

        choosen() {
            if (!this.isValidate) {
                this.deleteItem();
            } else {
                this.validateItem();
            }
        },

        deleting(item) {
            this.isValidate = false
            if (Array.isArray(item) && item.length > 0) {
                this.item = "multiple";
                this.ids = this.selected.map(item => {
                    return item.id;
                });
                this.isBulkDelete = true;
                this.dialog_title = "Suppression";
                this.delete_message =
                    "Etes-vous sûr de vouloir supprimer ces acteurs ?";
                this.dialog = true;
            } else {
                this.item = item.unique_code;
                if (Array.isArray(item) && item.length === 1) {
                    this.actorId = item[0].id;
                } else {
                    this.actorId = item;
                }

                this.isSingleDelete = true;
                this.dialog_title = "Suppression";
                this.delete_message =
                    "Etes-vous sûr de vouloir supprimer cet acteur de l'évenement?";
                this.dialog = true;
            }
        },

        async bulkGenerate() {
            this.loading = true
            try {
                await axios.post(`/api/actors/bulk-generate`, { ids: this.ids })
                this.reloadData()
                this.loading = false
                this.dialog = false
                this.snackbar = true
                this.selected = []
                this.isBulkGenerate = false
                this.isSingleGenerate = false
                this.snackbar_message = "Cartes d'acteurs générées avec succès!"
                this.cancel()
            } catch (error) {

                this.snackbar_error = true
                this.snackbar_message = "Une erreur c'est produit lors de la génération des cartes!"

                this.cancel()
            }

        },
        async deleteItem() {

            if (this.isBulkDelete && this.isBulkGenerate === false) {
                this.bulkDelete();
            } else if (this.isSingleDelete) {
                this.deleteSingle();
            }

            if (this.isBulkGenerate && this.isBulkDelete === false) {
                this.bulkGenerate()
            } else if (this.isSingleGenerate && this.isSingleDelete === false) {
                this.generateSingle()
            }
        },

        async generateSingle() {
            try {
                this.loading = true
                await axios.post(`/api/actors/generate/${this.actorId}`)
                this.reloadData()
                this.loading = false
                this.dialog = false
                this.snackbar = true
                this.selected = []
                this.snackbar_message = "La carte de l'acteur a été généré avec succès!"
                this.cancel()
            } catch (error) {

                this.snackbar_error = true
                this.snackbar_message = "Une erreur c'est produit lors de la génération des cartes!"
                this.cancel()
            }
        },

        async deleteSingle() {
            this.loading = true;
            const event_id = this.$route.params.Pid
            await axios.post(`/api/delete-event-participants`, { ids: [this.actorId], event_id });
            this.fetchUtils();
            this.loading = true;
            this.reloadData();
            this.dialog = false;
            this.snackbar = true;
            this.selected = [];
            this.isBulkDelete = false;
            this.isSingleDelete = false;
            this.snackbar_message = "Acteur supprimé avec succès!";
            this.cancel()
        },
        async bulkDelete() {
            this.loading = true;
            const event_id = this.$route.params.Pid
            await axios.post(`/api/delete-event-participants`, { ids: this.ids, event_id });
            this.fetchUtils();
            this.loading = true;
            this.reloadData();
            this.dialog = false;
            this.snackbar = true;
            this.selected = [];
            this.isBulkDelete = false;
            this.isSingleDelete = false;
            this.snackbar_message = "Acteurs supprimés avec succès!";
        },

        async printTable(header) {
            this.loadingSave = true;
            this.dialog_export = false;

            const uri = "/api/events/print";
            let objet = {};
            objet.event_id = this.event_id;

            let tab = this.current_event.actors;
            let liste = [];
            tab.forEach(function (item) {
                liste.push(item.id);
            });

            objet.participant_ids = liste;
            objet.name = this.current_event.name;
            objet.type = this.current_event.type;
            objet.jour = this.current_event.event_date;
            objet.place = this.current_event.place;
            objet.header = header;

            await axios
                .post(uri, objet, { responseType: "blob" })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Liste_presence.xlsx");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(err => {
                    console.log("Export error ", err);
                });

            this.loadingSave = false;
        },

        export2image() {
            let bar_graphe = this.$refs.mychartbar;
            let donut_graphe = this.$refs.mychartdonut;
            bar_graphe.printBarGraphe();
            donut_graphe.printDonutGraphe();
        },


        isClosingEvent() {
            this.dialog_closing = true;
        },

        cloturerEvent() {
            let objet = {};
            objet.event_id = this.event_id;
            let uri = "/api/events-close";
            let route_obj = this.$router;

            axios
                .post(uri, objet)
                .then(response => {
                    route_obj.push({
                        name: "events.coming",
                        params: { event_closed: true }
                    });
                })
                .catch(err => {
                    console.log("Export error ", err);
                });
        },

        reloadData(value) {
            let objet = {};
            objet.event_id = this.event_id;
            objet.page = this.pagination.current;

            if (this.search_name.length !== 0) {
                objet.search_name = this.search_name;
            }

            this.$store.dispatch("loadEventActors", objet);
        },

        searchWithDelay() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
                this.searchTimer = null;
            }

            this.searchTimer = setTimeout(() => {
                this.reloadData();
            }, 1000);
        },

        getContactNotificationStatus(contact) {
            let status = "pending";
            if (
                this.voice_mail_statistics &&
                this.voice_mail_statistics.tasks
            ) {
                this.voice_mail_statistics.tasks.forEach(task => {
                    if (task.contacts_messages_status) {
                        for (
                            let i = 0;
                            i < task.contacts_messages_status.length;
                            i++
                        ) {
                            if (
                                task.contacts_messages_status[i] &&
                                task.contacts_messages_status[i].to === contact
                            ) {
                                status =
                                    task.contacts_messages_status[i].status;
                            }
                        }
                    }
                });
            }
            // console.log(contact, status);
            return status;
        },

        cancel() {
            this.isBulkDelete = false;
            this.isSingleDelete = false;
            this.isBulkGenerate = false;
            this.dialog = false;
            this.dialog_generate = false;
        },


        async fetchParticipants() {
            this.loading = true;
            const uri = "/api/actors?searchName=" + this.number;
            await axios
                .get(uri)
                .then(response => {
                    this.participants = response.data.data;
                })
                .catch(err => {
                    console.log("Actor error ", err);
                });

            this.loading = false;
        },

        async dowloadCards() {
            this.dialog_dowload = true;
            let uri = '/api/event/cards?event_id=' + this.$route.params.Pid
            await axios
                .get(uri, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'event-' + this.$route.params.Pid + '-participant-card.zip')
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(err => {
                    console.log('Export error ', err)
                    this.snackbar_message = true
                    this.snackbar_message = "Une erreur c'est produit lors du téléchargement des cartes!"

                    this.cancel()
                })
            this.dialog_dowload = false
        },
        async validating() {
            this.loading = true;
            this.selected.forEach(actor => {
                const uri = "/api/events/presence";
                axios.post(uri, {
                    actor_id: actor.id,
                    event_id: this.event_id,
                    is_new: false
                });
            });
            this.selected = [];
            this.participants = null;
            this.number = null;
            this.dialog_add = false;
            this.is_search = false;
            this.loading = false;
            this.fetchUtils();
        }
    }
};
</script>

<style scoped>
.newTaille {
    font-size: 1.1em;
    color: black;
}

.name-size {
    font-size: 1.3em;
    color: black;
}

.couleur-orange {
    color: rgb(255, 152, 0);
    font-size: 1.2em;
}

.white-couleur {
    color: white;
}

.v-data-table-header {
    background-color: rgb(120, 185, 67);
    color: rgb(255, 255, 255);
}

.theme--light.v-table thead th {
    color: rgb(255, 255, 255);
}

.theme--light.v-datatable thead th.column.sortable.active {
    color: rgb(255, 255, 255);
}

.a-sans-style a {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/events/show.vue